export const timeoutCall = (props) => {
  setTimeout(() => {
    props();
  }, 3000);
};